import { SIGNUP_CODE } from "../lib/constants/actions";
export const signupCodes = (state = {}, action) => {
    switch (action.type) {

        case SIGNUP_CODE.GET_SIGNUP_CODES_SUCCESS:
            return { ...state, codes: action.payload }

        case SIGNUP_CODE.SAVE_SIGNUP_CODE_SUCCESS:
            return { ...state, saved: action.payload }

        case SIGNUP_CODE.DELETE_SIGNUP_CODE_SUCCESS:
            return { ...state, deleted: action.payload };
        
        default:
            return state;
    }
};




